export default __webpack_public_path__ + "fonts/import-contacts-img.svg";